import { textStyles } from "../../../../shared/theme/fonts-ppv";

export default {
	sortingSection: {
        ...textStyles.button2,
		display: 'flex',
		gap: '2px',
	},
    pointer: {
        cursor: 'pointer'
    },
    notAllowed: {
        cursor: 'not-allowed'
    },
};
